'use client'

import { Wrapper, CardLink, ImageSection } from '../BaseListingCard/Card'
import { ListingInfoSkeleton } from '../BaseListingCard/ListingInfo'
import { ImageSkeleton } from './ui'

const ListingCardSkeleton = () => {
  // Skeleton roughly matches a "typical" listing
  // (SPOT AUCTION w/ long title and all optional details available to show)
  return (
    <Wrapper>
      <CardLink as="span" data-testid="listing-card-skeleton">
        <ImageSection>
          <ImageSkeleton data-testid="image-skeleton" />
        </ImageSection>

        <ListingInfoSkeleton />
      </CardLink>
    </Wrapper>
  )
}

export default ListingCardSkeleton
